import "./Workflows.css";
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useUserProfile } from "../../service/hooks";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import {
  Container,
  Button,
  Navbar,
  Image,
  Badge,
  Nav,
  Dropdown,
  DropdownDivider,
  Spinner,
  Card,
  Breadcrumb,
  Row,
  Col,
} from "react-bootstrap";

import { useHistory, useParams, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faSignOutAlt,
  faMagicWandSparkles,
  faEnvelope,
  faPerson,
  faCheckCircle,
  faShieldAlt,
  faUserEdit,
  faLink,
  faCompassDrafting,
  faMusic,
  faFileContract,
  faCalculator,
  faUsers,
  faTools,
  faChartLine,
  faFileAlt,
  faRoute,
  faInfoCircle,
  faIdBadge,
  faBalanceScale,
} from "@fortawesome/free-solid-svg-icons";

import Logo from "../../beatai-logo.svg";

import {
  changeAvatar,
  resendVerification,
} from "../../service/api";

import Avatar, { useAvatar } from "../auth/Avatar";
import { useSocket } from "../../service/sockt";
import ContractGenerator from "../tools/contracts-maker";
import BudgetPlanner from "../tools/budget-planner";
import { Route, Switch, useRouteMatch } from "react-router-dom/cjs/react-router-dom.min";
import { getTotalRuns } from "../../service/workflow-api";
import EventsPlannerIndex from "../tools/event-logistics";
import CompetitorAndMarketResearch from "../tools/comp-market-research";
import CompMarketResearchWithRoutes from "../tools/comp-market-research";
import ContractAnalyzer from "../tools/contract-analyzer";
import MaintenancePlanner from "../tools/maintenance-planner";
import AiTourPlanner from "../tools/ai-tour-planner";

const AIWorkflowTools = () => {

  const [runData, setTotalRuns] = useState(0);
  const [current_plan, setCurrentPlan] = useState(() => {
    try {
      // Try to parse as JSON first (new format)
      const savedPlan = localStorage.getItem("current_plan");
      if (!savedPlan) return null;
      
      const parsedPlan = JSON.parse(savedPlan);
      // Return the text value from the parsed object
      return parsedPlan.text;
    } catch (e) {
      // If parsing fails, it's likely in the old string format
      // Just return the raw value
      return localStorage.getItem("current_plan");
    }
  });

  // Determine if the user is on a free plan or has no plan
  const isFreePlan = !current_plan || current_plan.toLowerCase() === 'free';

  useEffect(() => {
    getTotalRuns()
      .then((data) => {
        setTotalRuns(data);
      })
      .catch((error) => console.error("Error fetching total runs:", error));
  }, []);

  const history = useHistory();
  let { path } = useRouteMatch();

  // Handler for card click that checks for free plan before navigation
  const handleCardClick = (toolPath) => {
    if (!isFreePlan) {
      history.push(`${path}${toolPath}`);
    } else {
      history.push("/membership");
    }
  };

  const tools = [
    {
      id: 1,
      title: "AI Powered Event Budget Planner",
      icon: faCalculator,
      badges: ["Event Organizers", "Venue Owners"],
      color: "rgba(103, 58, 183, 0.3)",
      gradient: "rgba(149, 117, 205, 0.25)",
      credit: 15,
      path: "ai-budget-planner"
    },
    {
      id: 2,
      title: "AI Based Event Logistics & Staff Planning",
      icon: faUsers,
      badges: ["Venue Owners", "Event Organizers", "Technical"],
      color: "rgba(81, 45, 168, 0.3)",
      gradient: "rgba(126, 87, 194, 0.25)",
      credit: 20,
      path: "ai-logistics-staff-planning"
    },
    {
      id: 3,
      title: "Predictive Maintenance Planner",
      icon: faTools,
      badges: ["Technical", "Venue Owners"],
      color: "rgba(94, 53, 177, 0.3)",
      gradient: "rgba(140, 98, 197, 0.25)",
      credit: 15,
      path: "ai-predictive-maintenance-planner"
    },
    {
      id: 4,
      title: "AI Based Competitor & Market Analysis",
      icon: faChartLine,
      badges: ["Artists", "Venue Owners", "Event Organizers"],
      color: "rgba(123, 31, 162, 0.3)",
      gradient: "rgba(171, 71, 188, 0.25)",
      credit: 25,
      path: "ai-comp-market-research"
    },
    {
      id: 5,
      title: "Contract Analyzer & Summeriser",
      icon: faBalanceScale,
      badges: ["Event Organizers", "Artists", "Venue Owners"],
      color: "rgba(106, 27, 154, 0.3)",
      gradient: "rgba(156, 39, 176, 0.25)",
      credit: 10,
      path: "ai-contract-analyzer-summeriser"
    },
    {
      id: 6,
      title: "Contract Maker",
      icon: faFileContract,
      badges: ["Venue Owners", "Artists", "Event Organizers"],
      color: "rgba(69, 39, 160, 0.3)",
      gradient: "rgba(116, 77, 189, 0.25)",
      credit: 25,
      runattr: "contract_maker_runs",
      path: "ai-contract-maker"
    },
    {
      id: 7,
      title: "World Tour - AI Events Planner",
      icon: faRoute,
      badges: ["Artists", "Event Organizers"],
      color: "rgba(81, 45, 168, 0.3)",
      gradient: "rgba(126, 87, 194, 0.25)",
      credit: 20,
      path: "ai-tour-planner",
    },
  ];

  return (
    <Container className="mt-4">
      
      {isFreePlan && (
        <div 
          className="mb-4 p-3" 
          style={{
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
            borderRadius: "12px",
            border: "1px solid rgba(255, 255, 255, 0.08)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 24px",
            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div style={{ color: "white", fontWeight: "500" }}>
            To use AI Workflows, please Upgrade to a Paid Plan.
          </div>
          <Button 
            onClick={() => history.push("/membership")}
            style={{
              background: "linear-gradient(135deg, #8e24aa, #673ab7)",
              border: "none",
              boxShadow: "0 4px 10px rgba(142, 36, 170, 0.3)",
              padding: "8px 20px",
              borderRadius: "8px",
              fontWeight: "600",
              fontSize: "0.9em",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 6px 15px rgba(142, 36, 170, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 4px 10px rgba(142, 36, 170, 0.3)";
            }}
          >
            Upgrade
          </Button>
        </div>
      )}
      
      <Breadcrumb style={{ color: "white" }}>
        <Breadcrumb.Item active  style={{ color: "white" }}>AI Workflows</Breadcrumb.Item>
      </Breadcrumb>

      <Row xs={1} md={2} lg={3} className="g-4">
        {tools.map((tool) => (
          <Col key={tool.id}>
            <Card
              className={`tool-card ${isFreePlan ? 'disabled-card' : ''}`}
              onClick={() => handleCardClick(tool.path)}
              style={{
                background: `linear-gradient(135deg, ${tool.color}, ${tool.gradient})`,
                color: "#ffffff",
                backdropFilter: "blur(10px)",
                textAlign: "left",
                padding: "25px",
                border: "1px solid rgba(255, 255, 255, 0.08)",
                borderRadius: "16px",
                cursor: !isFreePlan ? "pointer" : "not-allowed",
                transition: "all 0.3s ease-in-out",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "space-between",
                position: "relative",
                minHeight: "220px",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
                WebkitBackdropFilter: "blur(10px)",
                opacity: !isFreePlan ? 1 : 0.6,
              }}
              onMouseEnter={(e) => {
                if (!isFreePlan) {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.15)";
                  e.currentTarget.style.border = "1px solid rgba(255, 255, 255, 0.12)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isFreePlan) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
                  e.currentTarget.style.border = "1px solid rgba(255, 255, 255, 0.08)";
                }
              }}
            >
              {isFreePlan && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(0, 0, 0, 0.4)",
                    borderRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  <div style={{
                    background: "rgba(255, 255, 255, 0.15)",
                    padding: "8px 15px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    fontSize: "0.9em",
                    backdropFilter: "blur(5px)",
                    WebkitBackdropFilter: "blur(5px)",
                  }}>
                    Upgrade Required
                  </div>
                </div>
              )}
              
              <div
                style={{
                  position: "absolute",
                  top: "15px",
                  right: "15px",
                  background: "rgba(255,255,255,0.1)",
                  padding: "4px 12px",
                  borderRadius: "20px",
                  fontSize: "0.7em",
                  fontWeight: "500",
                  letterSpacing: "0.5px",
                  backdropFilter: "blur(5px)",
                  WebkitBackdropFilter: "blur(5px)",
                  border: "1px solid rgba(255, 255, 255, 0.05)"
                }}
              >
                {runData[tool.runattr] || 0} runs
              </div>

              <Card.Body style={{ padding: 0, width: "100%" }}>
                <div style={{ marginBottom: "20px" }}>
                  <FontAwesomeIcon 
                    icon={tool.icon} 
                    size="2x" 
                    style={{
                      background: "rgba(255, 255, 255, 0.15)",
                      padding: "12px",
                      borderRadius: "12px",
                      marginBottom: "15px"
                    }}
                  />
                </div>
                <Card.Title
                  style={{
                    fontSize: "1.1em",
                    fontWeight: "600",
                    marginBottom: "15px",
                    lineHeight: "1.4"
                  }}
                >
                  {tool.title}
                </Card.Title>
                
                <div className="d-flex flex-column" style={{ gap: "10px", marginTop: "auto" }}>
                  <div className="d-flex flex-wrap gap-2">
                    {tool.badges.map((badge, index) => (
                      <Badge
                        key={index}
                        bg="none"
                        style={{ 
                          fontSize: "0.7em",
                          background: "rgba(255,255,255,0.15)",
                          color: "#ffffff",
                          padding: "5px 10px",
                          borderRadius: "8px",
                          fontWeight: "500",
                          backdropFilter: "blur(5px)"
                        }}
                      >
                        {badge}
                      </Badge>
                    ))}
                  </div>
                  
                  <div 
                    style={{ 
                      fontSize: "0.8em",
                      color: "#ffffff",
                      opacity: "0.9",
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px"
                    }}
                  >
                    <FontAwesomeIcon icon={faInfoCircle} />
                    <span>Uses <strong>{tool.credit}</strong> credits</span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

function AIWorkflows() {
  useEffect(() => {
    document.title = "BeatAI - AI Workflows";
  }, []);
  const [show, setShow] = useState(false);

  const history = useHistory();
  const handleShow = () => setShow(true);
  const verified = localStorage.getItem("verified");
  const [resendingMail, setResendingMail] = useState(false);
  const { firstname, lastname } = useUserProfile();
  
  const { isConnected, emit, subscribe, unsubscribe } = useSocket(
    localStorage.getItem("accessToken")
  );

  const modelChangeToast = (txt) =>
    toast(txt, {
      position: "top-right",
    });

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    history.push("/login?sc=ef5199c2-e6b8-4257-9932-20aa6f449c90R");
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      style={{
        textDecoration: "none",
      }}
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
  ));


  // Scroll to bottom

  const { setAvatarB64, getAvatarB64 } = useAvatar();
  const [avatarB64Local, setAvatarB64Local] = useState(null);
  const [changingAvatar, setChangingAvatar] = useState(false);

  const handleFileChange = async (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    const file = event.target.files[0];

    // Validate file type (JPEG/PNG)
    if (!["image/jpeg", "image/png"].includes(file.type)) {
      alert("Only JPEG and PNG formats are allowed.");
      return;
    }

    try {
      setChangingAvatar(true);
      await changeAvatar(file);
      alert("Avatar updated successfully!");

      // Fetch and update the base64 image in the hook state
      const avatar = await getAvatarB64(true);
      setAvatarB64Local(avatar);
      setChangingAvatar(false);
    } catch (error) {
      alert(error.message);
      setChangingAvatar(false);
    }
  };
  useEffect(() => {
    setChangingAvatar(true);

    getAvatarB64()
      .then((avatar) => {
        setChangingAvatar(false);
        setAvatarB64Local(avatar);
      })
      .catch((e) => {
        setChangingAvatar(false);
      });
  }, []);

  const uploadAvatarRef = useRef(null);

  const [showModelComparison, setShowModelComparison] = useState(false);
  let { path } = useRouteMatch();

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="sm" className="w-100 m-0 nav_">
        <Container fluid className="">
          <input
            hidden
            ref={uploadAvatarRef}
            type="file"
            accept="image/jpeg,image/png"
            onChange={handleFileChange}
          />
          <Button
            variant="outline-light"
            onClick={handleShow}
            className="border-0"
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
          <Navbar.Brand
            className=""
            style={{ cursor: "pointer" }}
            title="+ Start new chat"
            onClick={(e) => history.push("/chat/")}
          >
            <Image src={Logo} style={{ maxWidth: "100px" }} />
          </Navbar.Brand>
          <Nav className="" style={{ width: "80%" }}>
            <Nav.Link
              as={Link}
              to="/chat"
              className={
                window.location.href.indexOf("chat") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              Chat
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/ai-images/"
              className={
                window.location.href.indexOf("ai-image") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <FontAwesomeIcon icon={faMagicWandSparkles} /> AI Images
            </Nav.Link>
            <Nav.Link
              as={Link}
              title="Coming Soon!"
              to="/ai-workflows/"
              className={
                window.location.href.indexOf("ai-workflows") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <FontAwesomeIcon icon={faCompassDrafting} /> Workflows
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/beats"
              title="Coming Soon!"
              className={
                window.location.href.indexOf("beats") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <FontAwesomeIcon icon={faMusic} /> Beats
            </Nav.Link>
          </Nav>
          <Dropdown align="end" className="user-avatar-dropdown">
            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
              <div className="user-avatar" style={{ textAlign: "center" }}>
                {!avatarB64Local &&
                  !changingAvatar &&
                  (firstname ? (
                    firstname[0]
                  ) : (
                    <FontAwesomeIcon icon={faPerson} />
                  ))}
                {!changingAvatar && avatarB64Local && (
                  <Avatar
                    base64Image={avatarB64Local}
                    width="30px"
                    height="30px"
                  />
                )}
                {changingAvatar && <Spinner size="sm" />}
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Container fluid>
                <Container className="text-center">
                  <div
                    className="user-avatar"
                    style={{ margin: "0 auto", width: "80px", height: "80px" }}
                    onClick={() => {
                      if (uploadAvatarRef.current) {
                        uploadAvatarRef.current.click();
                      }
                    }}
                  >
                    {!avatarB64Local &&
                      !changingAvatar &&
                      (firstname ? (
                        firstname[0]
                      ) : (
                        <FontAwesomeIcon icon={faPerson} />
                      ))}
                    {!changingAvatar && avatarB64Local && (
                      <Avatar
                        base64Image={avatarB64Local}
                        width="70px"
                        height="70px"
                      />
                    )}
                    {changingAvatar && <Spinner size="sm" />}
                  </div>
                  <br />
                  <p
                    style={{
                      fontSize: "0.7em",
                      color: "white",
                      margin: "0 auto",
                    }}
                  >
                    {firstname} {lastname}
                  </p>
                </Container>
              </Container>
              <Dropdown.Divider />
              <Dropdown.Item
                className="user-avt-dd-itm"
                onClick={() => {
                  if (uploadAvatarRef.current) {
                    uploadAvatarRef.current.click();
                  }
                }}
              >
                <FontAwesomeIcon icon={faUserEdit} className="me-2" /> Change
                Avatar
              </Dropdown.Item>
              <Dropdown.Item
                className="user-avt-dd-itm"
              >
                <Link
                  to="/membership"
                  style={{
                    textDecoration: "none",
                    color: "white",
                  }}
                >
                  <FontAwesomeIcon icon={faIdBadge} className="me-2" />{" "}
                  Membership
                </Link>
              </Dropdown.Item>
              <Dropdown.Item className="user-avt-dd-itm">
                <Link
                  to="/account-settings"
                  style={{
                    textDecoration: "none",
                    color: "white",
                  }}
                >
                  <FontAwesomeIcon icon={faShieldAlt} className="me-2" />{" "}
                  Account Settings
                </Link>
              </Dropdown.Item>
              <Dropdown.Item
                className="user-avt-dd-itm"
                onClick={() => {
                  window.open("https://beatbind.io/privacy", "_blank");
                }}
              >
                <FontAwesomeIcon className="me-2" icon={faLink} />
                <a
                  style={{
                    color: "white",
                  }}
                  href="https://beatbind.io/privacy"
                  target="_blank"
                >
                  Privacy Policy
                </a>
              </Dropdown.Item>
              <Dropdown.Item className="user-avt-dd-itm" onClick={handleLogout}>
                <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {verified === "false" ? (
            <i className="ms-auto">
              <Badge>Unverified</Badge>
            </i>
          ) : null}
        </Container>
      </Navbar>
      <Container>
        {resendingMail && (
          <>
            <Spinner size="sm" /> Resending mail
          </>
        )}
        {!resendingMail && verified === "false" && (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setResendingMail(true);
              resendVerification()
                .then(() => {
                  setResendingMail(false);
                  alert("Link sent!");
                })
                .catch((e) => {
                  setResendingMail(false);
                  alert("Couldn't send, please try again later!");
                });
            }}
          >
            <FontAwesomeIcon icon={faEnvelope} />{" "}
            <u>Resend Verification Link</u>
          </span>
        )}
        <br />
        <Switch>
          <Route exact path={`${path}/`} component={AIWorkflowTools} />
          <Route path={`${path}/ai-contract-maker`} component={ContractGenerator} />
          <Route path={`${path}/ai-budget-planner`} component={BudgetPlanner} />
          <Route path={`${path}/ai-logistics-staff-planning`} component={EventsPlannerIndex} />
          <Route path={`${path}/ai-predictive-maintenance-planner`} component={MaintenancePlanner} />
          <Route path={`${path}/ai-comp-market-research`} component={CompMarketResearchWithRoutes} />
          <Route path={`${path}/ai-contract-analyzer-summeriser`} component={ContractAnalyzer} />
          <Route path={`${path}/ai-tour-planner`} component={AiTourPlanner} />
        </Switch>
      </Container>
      <ToastContainer />
    </>
  );
}

export default AIWorkflows;
